import React, { useState } from "react";
import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	Chip,
	Stack,
	Typography,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import { EventoSimpleEditDialog } from "./EventoSimpleEditDialog";
import { formatoHorarioEvento, getEventType, getTextoEncargadosEvento } from "./eventosUtils";

export const EventoInfoCard = ({ evento, opTrabajadores, onChange }) => {
	const [editar, setEditar] = useState(false);
	const tipo = getEventType(evento.id_tipo_evento);
	const TipoIcon = tipo.icon;
	const esLimpieza = Number(evento.id_tipo_evento) === 2;
	const esRopa = Number(evento.id_tipo_evento) === 4;
	const encargados = getTextoEncargadosEvento(evento, opTrabajadores);

	return (
		<Card className={`events-info-card ${tipo.className}`}>
			<CardContent className="events-info-card-content">
				<Box className="events-info-top">
					<Box className="events-info-icon">
						<TipoIcon />
					</Box>
					<Box className="events-info-title-block">
						<Typography variant="h6" className="events-info-title" title={evento.asunto || evento.descripcion}>
							{evento.asunto || evento.descripcion || tipo.label}
							{esRopa && evento.color_ropa && (
								<span className="events-clothes-card-dot" style={{ backgroundColor: evento.color_ropa }} />
							)}
						</Typography>
						<Stack direction="row" className="events-info-meta">
							<span className={esLimpieza ? "events-cleaning-date-alert" : ""}>
								<AccessTimeIcon fontSize="inherit" />
								{formatoHorarioEvento(evento)}
								{esLimpieza && <WarningAmberIcon fontSize="inherit" />}
							</span>
						</Stack>
					</Box>
					<Chip label={tipo.label} className="events-info-chip" />
				</Box>

				{!esRopa && evento.descripcion && evento.descripcion !== evento.asunto && (
					<Typography className="events-info-description">
						{evento.descripcion}
					</Typography>
				)}

				{!esRopa && (
					<Box className="events-info-owner-row">
						<PersonIcon fontSize="small" />
						<Typography className="events-info-owner">
							{encargados.label}: {encargados.texto}
						</Typography>
					</Box>
				)}
			</CardContent>

			<CardActions className="events-info-actions">
				<Button
					size="small"
					variant="outlined"
					startIcon={<EditIcon />}
					disabled={evento.opciones !== 1}
					onClick={() => setEditar(true)}
				>
					Editar
				</Button>
			</CardActions>

			{editar && (
				<EventoSimpleEditDialog
					open={editar}
					onClose={() => setEditar(false)}
					evento={evento}
					opTrabajadores={opTrabajadores}
					onSaved={onChange}
				/>
			)}
		</Card>
	);
};
